// extracted by mini-css-extract-plugin
export default {"container":"home_container__H4r93","container_small":"home_container_small__j1+Dw","container-lg":"home_container-lg__IvyqK","main":"home_main__EOz+7"};